/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum FlectoLanguages {
  EN = 'en',
  PT = 'pt',
  ES = 'es',
  DEFAULT = 'pt',
}
